import React from 'react';
import { CheckCircle, MapPin, Building, Calendar } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const BuhasaTieInsPage = () => {
  const disciplines = [
    'Process Engineering',
    'Piping Engineering',
    'Pipeline Engineering',
    'Mechanical Engineering',
    'Electrical Engineering',
    'Instrumentation & Control Engineering',
    'Civil & Structural Engineering'
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: 'url(https://customer-assets.emergentagent.com/job_precision-vision/artifacts/08dpscyk_BU%20Hasa.jpg)'
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 to-slate-900/70" />
        </div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Buhasa Tie-Ins (2021-2025) Package 1(P12516) ADNOC Onshore
          </h1>
          <div className="flex flex-wrap justify-center gap-6 mt-6">
            <div className="flex items-center gap-2">
              <MapPin className="w-5 h-5" />
              <span className="text-lg">Abu Dhabi, UAE</span>
            </div>
            <div className="flex items-center gap-2">
              <Building className="w-5 h-5" />
              <span className="text-lg">ADNOC</span>
            </div>
            <div className="flex items-center gap-2">
              <Calendar className="w-5 h-5" />
              <span className="text-lg">2022-2024</span>
            </div>
          </div>
        </div>
      </section>

      {/* Project Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Project <span className="text-red-600">Overview</span>
            </h2>
            <div className="w-24 h-1 bg-red-600 mb-8" />
            <p className="text-lg text-slate-700 leading-relaxed mb-6">
              This involves EPC services to connect newly drilled smart wells to main production facilities in the Bu Hasa field.
            </p>
          </div>

          {/* Detailed Engineering Services */}
          <div>
            <h3 className="text-2xl font-bold text-slate-900 mb-6">
              Detailed Engineering Services for Well Tie-ins
            </h3>
            <p className="text-slate-700 mb-6">
              Total Vision delivers comprehensive engineering services to ensure seamless integration of smart wells with existing production infrastructure:
            </p>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {disciplines.map((discipline, index) => (
                <Card key={index} className="border-none shadow-lg hover:shadow-xl transition-all duration-300">
                  <CardContent className="p-6">
                    <div className="flex items-start gap-3">
                      <CheckCircle className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" />
                      <span className="text-slate-700 text-base font-medium">{discipline}</span>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Project Significance */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold text-slate-900 mb-6">Project Significance</h3>
            <p className="text-lg text-slate-700 leading-relaxed">
              The Buhasa Tie-Ins project is essential for maximizing production from ADNOC Onshore's Bu Hasa field by 
              efficiently connecting newly drilled smart wells to existing production facilities. This EPC initiative ensures 
              optimal field performance through advanced well tie-in engineering, incorporating state-of-the-art process, 
              piping, pipeline, mechanical, electrical, instrumentation, and civil engineering solutions.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BuhasaTieInsPage;